'use client';

import { c as _c } from "react/compiler-runtime";
import { type ReactNode, type ReactElement } from 'react';
import { ErrorBoundary, type FallbackProps } from 'react-error-boundary';
import { usePathname } from 'next/navigation';
import NotFoundPage from './NotFoundPage';
import { type ApiClientError } from 'shared/api/fetch';
import { HttpStatusCodes } from 'shared/httpStatus';
const FallbackComponent = t0 => {
  const $ = _c(1);
  const {
    error
  } = t0;
  const apiError = error as ApiClientError;
  if (apiError.status_code === HttpStatusCodes.NOT_FOUND) {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <NotFoundPage hasDashboardFrame={true} />;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    return t1;
  }
  throw error;
};
const NotFoundErrorBoundary = t0 => {
  const $ = _c(5);
  const {
    children
  } = t0;
  const pathname = usePathname();
  let t1;
  if ($[0] !== pathname) {
    t1 = [pathname];
    $[0] = pathname;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== children || $[3] !== t1) {
    t2 = <ErrorBoundary FallbackComponent={FallbackComponent} resetKeys={t1}>{children}</ErrorBoundary>;
    $[2] = children;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};
export default NotFoundErrorBoundary;